$(document).ready(function(){ 
    $('#country-name').val('223').change(); 
});

// get state 
jQuery(document).on('change', 'select#country-name', function (e) {
    e.preventDefault();
    var countryID = jQuery(this).val();
    getStatesList(countryID);
});

// get city
jQuery(document).on('change', 'select#state-name', function (e) {
    e.preventDefault();
    var stateID = jQuery(this).val();
    getCityList(stateID);
});

// Global function get All States
function getStatesList(countryID) {
    $.ajax({
      url: "https://store.cilek.com/location/getstates",
        type: 'post',
        data: {countryID: countryID},
        dataType: 'json',
        beforeSend: function () {
            jQuery('select#state-name').find("option:eq(0)").html("Please wait..");
        },
        complete: function () {
            // code
        },
        success: function (json) {
            var options = '';
            options +='<option value="">Select</option>';
            for (var i = 0; i < json.length; i++) {
                options += '<option value="' + json[i].state_id + '">' + json[i].state_name + '</option>';
            }
            jQuery("select#state-name").html(options);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
}

// Global function get All Cities
function getCityList(stateID) {
    $.ajax({
        url: "https://store.cilek.com/location/getcities",
        type: 'post',
        data: {stateID: stateID},
        dataType: 'json',
        beforeSend: function () {
            jQuery('#city-name').find("option:eq(0)").html("Please wait..");
        },
        complete: function () {
            // code
        },
        success: function (json) {
            var stores = '';

            for (var i = 0; i < json.length; i++) {
                var storeName = json[i].city_name;

                if(json[i].city_description == ""){
                    stores += '' +
                        '<div style="grid-template-rows: auto;" class="smargin grid__item small--one medium-up--one-quarter">' +
                        '<div>' +
                        '<h3 class="title"><a href="https://maps.google.com/maps?q=' + json[i].city_latitude +','+ json[i].city_longitude + '">' +
                            storeName +
                        '</a></h3>' +
                        '<p class="location-adress">' +
                            json[i].city_address +
                        '</p>' + 
                        '<p class="wp-link_store0" style="margin-bottom: 20px;""> <a href="tel:' + json[i].city_phone +'" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            json[i].city_phone +
                        '</a>' +
                        '</p>' +
                        '<p class="wp-link_store0" style="margin-bottom: 20px;""> <a href="tel:' + json[i].city_phone_2 +'" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            json[i].city_phone_2 +
                        '</a>' +
                        '</p>' +
                        '</div>'+
                        '<div>' +
                        '<a class="btn get-direction-btn" href="https://maps.google.com/maps?q=' + json[i].city_latitude +','+ json[i].city_longitude + '" role="button" data-store="' + storeName + '">Get Direction</a>' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                } else {
                    stores += '' +
                        '<div style="grid-template-rows: auto;" class="smargin grid__item small--one medium-up--one-quarter">' +
                        '<div>' +
                        '<h3 class="title"><a href="https://maps.google.com/maps?q=' + json[i].city_latitude +','+ json[i].city_longitude + '">' +
                            storeName +
                        '</a></h3>' +
                        '<p class="location-adress">' +
                            json[i].city_address +
                        '</p>' + 
                        '<p class="wp-link_store1" style="margin-bottom: 20px;""><img class="wp-icon_store" src="https://cdn.shopify.com/s/files/1/0267/7548/6653/files/whatsapp-store.png?v=1654860038"><a target="_blank" class="wp_link whatsapp-btn" href="https://wa.me/'+json[i].city_description +'?text=Merhaba" data-store="' + storeName + '"> ' +
                            "WhatsApp İletişim" +
                        '</a>' +
                        '</p>' +
                        '<p class="wp-link_store0" style="margin-bottom: 20px;""> <a href="tel:' + json[i].city_phone +'" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            json[i].city_phone +
                        '</a>' +
                        '</p>' +
                        '<p class="wp-link_store0" style="margin-bottom: 20px;""> <a href="tel:' + json[i].city_phone_2 +'" class="phone-call-btn" data-store="' + storeName + '"> ' +
                            json[i].city_phone_2 +
                        '</a>' +
                        '</p>' +
                        '</div>'+
                        '<div>' +
                        '<a class="btn get-direction-btn" href="https://maps.google.com/maps?q=' + json[i].city_latitude +','+ json[i].city_longitude + '" role="button" data-store="' + storeName + '">Get Direction</a>' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                }
            }
          
            jQuery("#city-name").html(stores);

            // GA4
            $('.get-direction-btn').on('click', function(e) {
                var storeName = $(this).data('store');
                gtag('event', 'get_direction', {
                    'event_category': 'Store Locator',
                    'store_name': storeName
                });
            });

            $('.whatsapp-btn').on('click', function(e) {
                var storeName = $(this).data('store');
                gtag('event', 'whatsapp_contact', {
                    'event_category': 'Store Locator',
                    'store_name': storeName
                });
            });

            $('.phone-call-btn').on('click', function(e) {
                var storeName = $(this).data('store');
                gtag('event', 'phone_call', {
                    'event_category': 'Store Locator',
                    'store_name': storeName
                });
            });
        },
        error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
}

// WhatsApp
if(typeof json !== 'undefined' && json[i] && json[i].city_description == undefined){
    let wpContent = document.querySelectorAll(".wp-link_store1");
    let wpContentArry = [...wpContent];
    for (wpContent of wpContentArry){
        wpContent.style.display= "none";
    }
}